import { Subject } from "rxjs";
import { EditableTransportOptionConstraint, TransportOption } from './transport-options.model';

export class OptionsContextChange {

    source: string;
    key: string;
    value: any;

    constructor(source: string, key: string, value?: any) {
        this.source = source;
        this.key = key;
        this.value = value;
    }
}

export class TransportOptionsAdministrationContext {

    dirty = false;
    optionsValid = true;
    constraintsValid = true;

    contextChange$ = new Subject<OptionsContextChange>();

    options = new Array<TransportOption>();
    deletedOptions = new Array<TransportOption>();

    constraints = new Array<EditableTransportOptionConstraint>();
    deletedConstraints = new Array<EditableTransportOptionConstraint>();

    selectedConstraint: EditableTransportOptionConstraint;

    public reset() {
        this.dirty = false;
        this.optionsValid = true;
        this.deletedOptions = new Array<TransportOption>();
        this.setOptions(new Array<TransportOption>(), 'transport-options-administration.context');
    }

    public setOptions(options: Array<TransportOption>, source: string) {
        this.options = options;
        this.contextChange$.next(new OptionsContextChange(source, 'options-changed', this.options));
    }

    public addDeletedOption(deletedOption: TransportOption) {
        this.deletedOptions.push(deletedOption);
    }

    public setConstraints(constraints: Array<EditableTransportOptionConstraint>, source: string) {
        this.constraints = constraints;
        this.validateConstraints();
        this.contextChange$.next(new OptionsContextChange(source, 'constraints-changed', this.constraints));
    }

    public addDeletedConstraint(deletedConstraint: EditableTransportOptionConstraint) {
        this.deletedConstraints.push(deletedConstraint);
    }

    public validateConstraints() {
        let valid = true;
        for (const c of this.constraints) {
            if (c.name == null || c.name.length === 0 || c.count == null || c.count < 0 || c.type == null) {
                valid = false;
                c.invalid = true;
            }
        }
        this.constraintsValid = valid;
    }
}
